(() => {
  if (!window.__HFTextBlockSeeMoreInit) {
    window.__HFTextBlockSeeMoreInit = function (scope) {
      const root = scope || document;
      const blocks = root.querySelectorAll('[data-text-block-see-more]');

      blocks.forEach((block) => {
        if (block.dataset.hfTextBlockReady === 'true') return;
        block.dataset.hfTextBlockReady = 'true';

        const content = block.querySelector('[data-text-block-content]');
        const button = block.querySelector('[data-text-block-toggle]');
        const toggleText = block.querySelector('[data-text-block-toggle-text]');

        if (!content || !button || !toggleText) return;

        const moreText = toggleText.dataset.moreText || 'Voir plus';
        const lessText = toggleText.dataset.lessText || 'Voir moins';

        const update = () => {
          const styles = getComputedStyle(block);
          const collapsedHeightValue =
            styles.getPropertyValue('--hf-text-block-collapsed-height').trim() ||
            styles.getPropertyValue('--hf-title-block-collapsed-height').trim() ||
            styles.getPropertyValue('--text-block-collapsed-height').trim();

          const collapsedHeight = parseInt(collapsedHeightValue, 10);

          if (!collapsedHeight) return;

          const isOverflowing = content.scrollHeight > collapsedHeight + 2;

          block.classList.toggle('is-overflowing', isOverflowing);

          if (!isOverflowing) {
            block.classList.remove('is-expanded');
            button.hidden = true;
            button.setAttribute('aria-expanded', 'false');
            toggleText.textContent = moreText;
          } else {
            button.hidden = false;
          }
        };

        button.addEventListener('click', () => {
          const isExpanded = block.classList.toggle('is-expanded');
          button.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
          toggleText.textContent = isExpanded ? lessText : moreText;
        });

        if (window.ResizeObserver) {
          const resizeObserver = new ResizeObserver(() => update());
          resizeObserver.observe(content);
        }

        update();
        window.requestAnimationFrame(update);
      });
    };

    const init = () => window.__HFTextBlockSeeMoreInit(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (event) => {
      window.__HFTextBlockSeeMoreInit(event.target);
    });

    document.addEventListener('shopify:block:select', () => {
      window.__HFTextBlockSeeMoreInit(document);
    });
  } else {
    window.__HFTextBlockSeeMoreInit(document);
  }
})();